import React from 'react';
import i18next from 'i18next';
import styled from 'styled-components';

import {LoginTextField} from 'web-app/react/login/shared-components';
import PlatformHelper from 'web-app/helpers/platform-helper';
import Button, {ButtonPosition, ButtonAppearance} from 'web-app/react/components/form-elements/button/button';
import {Caption} from 'web-app/react/components/text/text';
import ClosingDay from 'web-app/react/components/icons/legacy/lazy-icons/closing-day';
import {Flex} from 'web-app/react/components/layout/layout';
import {s2, s12, getSpacing} from 'web-app/styleguide/spacing';

interface InputProps {
    className?: string;
    handleSubmit: (twoFactorCode: string) => void;
}

const TwoFactorCodeField = styled(LoginTextField)`
    width: 160px;
`;

const SubmitButton = styled(Button)`
    margin-top: ${getSpacing(s12)};
`;

const TwoFactorInput: React.FC<React.PropsWithChildren<InputProps>> = props => {
    const {handleSubmit, className} = props;

    const [twoFactorCode, setTwoFactorState] = React.useState('');

    return (
        <Flex direction="column" className={className}>
            <Flex marginBottom={s2} direction="column" align="center">
                <ClosingDay size={64} transparent />
                <Caption secondary>{i18next.t('login.enterTwoFactorToProceed')}</Caption>
            </Flex>
            <TwoFactorCodeField
                type="text"
                placeholder={i18next.t('login.twoFactorPlaceholder')}
                autoFocus={!PlatformHelper.isIos()}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    setTwoFactorState(e.target.value);
                }}
            />
            <SubmitButton
                appearance={ButtonAppearance.confirm}
                position={ButtonPosition.fill}
                onClick={() => handleSubmit(twoFactorCode)}
                promiseOnClick
                disabled={!twoFactorCode}
            >
                {i18next.t('login.login')}
            </SubmitButton>
        </Flex>
    );
};

export default TwoFactorInput;
